import { buildUrl, usKidsGolfService } from '@/libs/api/instances/us-kids-golf-instance';
import type { RequestOptions } from '@/libs/api/types';

/** Path (relative to `buildUrl`) for the Contact Us / support request. */
export const CONTACT_ENDPOINT = '/contact';

/** Body for POST /api/v1/contact. */
export type SubmitContactRequest = {
  /** Sender's name. */
  name: string;
  /** Selected concern / question type, e.g. "product" | "coaching" | "tournament". */
  questionType: string;
  /** Optional free-text message from the guardian. */
  message?: string;
};

/**
 * Sends a Contact Us request via POST `/api/v1/contact`. Authenticated automatically
 * with the signed-in guardian's Firebase token; the backend routes the notification
 * email based on `questionType`.
 */
export async function submitContact(
  body: SubmitContactRequest,
  options?: RequestOptions,
): Promise<void> {
  await usKidsGolfService.post<void, SubmitContactRequest>(
    buildUrl(CONTACT_ENDPOINT),
    body,
    options,
  );
}
